var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 23.4999L23.5 31.3333L5.875 23.4999M41.125 31.3333L23.5 39.1666L5.875 31.3333M41.125 15.6666L23.5 23.4999L5.875 15.6666L23.5 7.83325L41.125 15.6666Z",
    stroke: "url(#paint0_linear_43_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_43",
    x1: 23.5,
    y1: 7.83325,
    x2: 23.5,
    y2: 39.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMision);
export default __webpack_public_path__ + "static/media/ic_mision.fe36fba0562f67a62b3bc3ac9a04e478.svg";
export { ForwardRef as ReactComponent };